import type { FC } from "react";
import React from "react";

export const PaymentFailPage: FC = () => (
  <>
    <h2>Отказ от оплаты :(</h2>
    <p>Вы можете повторить операцию в любое удобное для Вас время.</p>
  </>
);
